import { Icon } from '@iconify/react';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Fab from '../../../layouts/Fab';
import { setThreadToReply } from '../../../store/slices/replyContextSlice';

export function FloatingReplyButton() {
  const dispatch = useDispatch();
  const location = useLocation();

  const [isDisplayed, setIsDisplayed] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsDisplayed(true);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Fab>
      {isDisplayed && (
        <button
          id="replyThreadButton"
          className="grid h-full w-full grid-flow-col place-items-center items-center gap-2 rounded-full bg-indigo-300/70 hover:bg-indigo-300/90 dark:bg-indigo-800/90 dark:hover:bg-indigo-800 sm:py-2 sm:px-4"
          onClick={() => {
            dispatch(setThreadToReply(location.state.thread));
            document.getElementById('addCommentDialog').showModal();
          }}
        >
          <Icon icon="material-symbols:reply-rounded" />
          <div className="hidden font-medium sm:block">Reply</div>
        </button>
      )}
    </Fab>
  );
}
